import React,{useState,useEffect,useRef} from "react";
import './ReleaseMusic.css'
import { Trans, useTranslation} from 'react-i18next'
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import { useJwt, decodeToken } from "react-jwt";
import Cookies from "universal-cookie";
import {useLocation,useNavigate} from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';

function AlbumSummary({pagePath,setPagePath,setPageNo,albumImage,setAlbumImage,releaseTitle,artistName,genre,format,files,releaseDate,releaseDateError,createproduct,setTimeLeft}) {
    const ref = useRef(null)
    const {t, i18n } = useTranslation();
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const navigate = useNavigate();
    const cookies = new Cookies(null ,{ path: '/' });
    const location = useLocation();
    const [btnclicked,setBtnClicked] = useState(false)

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }

    const SubmitReleaseMusic =  () =>{
        createproduct(8)
    }


    
    useEffect(()=>{
      if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
          setPagePath("/Dashboard/releasemusic/albumsummary")
      }
    
      if(decodeToken(cookies.get('token')).info.role==="label"){
          setPagePath("/dashboard/label/releasemusic/albumsummary")
      }
    },[])

    return (
        <div style={{display:'flex',flexDirection:'column',alignItems:"center",paddingBottom:'3em'}} ref={ref}>
        <div className="AddMusicHeader"> {t('Reviewandsubmit')}</div>
  
       <div className="AddMusicDesc"> {t('Checkyourreleasedetails')}</div>

       <div className="ReviewReleaseContainer">
         <div style={{display:'flex',flexDirection:'row',width:'81.81%',justifyContent:'space-between',marginBottom:'1.5em'}}>
           <div className="SectionHeader">
           {t('Coverart')}
           </div>

           <div className="EditBtn" onClick={()=>{topFunction();  
                        if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                        navigate("/Dashboard/releasemusic/uploadphoto")
                      }
            
                      if(decodeToken(cookies.get('token')).info.role==="label"){
                        navigate("/dashboard/label/releasemusic/uploadphoto")
                      }}}>
           {t('Edit')}
             </div>
         </div>

         {
           albumImage.length===0 &&
           <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj"} style={{width:'13.18em',height:'13.62em',alignSelf:'flex-start',marginLeft:'5em',marginBottom:'4em',borderRadius:'8px'}}/>
         }

         {
            albumImage.length!==0 &&
            <img src={URL.createObjectURL(albumImage[0])} style={{width:'13.18em',height:'13.62em',alignSelf:'flex-start',marginLeft:'5em',marginBottom:'4em',borderRadius:'8px'}}/>
         }

       
         

         <div style={{display:'flex',flexDirection:'row',width:'81.81%',justifyContent:'space-between',marginBottom:'1.5em'}}>
           <div className="SectionHeader">
           {t('Album')} 
           </div>

           <div className="EditBtn" onClick={()=>{topFunction();
           if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
            navigate("/Dashboard/releasemusic/albumdetails")
          }

          if(decodeToken(cookies.get('token')).info.role==="label"){
            navigate("/dashboard/label/releasemusic/albumdetails")
          }
          }}>
           {t('Edit')}
             </div >
         </div>

         <div style={{display:'flex',flexDirection:'row',width:'81.81%',marginBottom:'1em'}}>
             <div className="AlbumInfoMeta"> {t('Title')}  </div>
             <div className="AlbumInfoValue">&nbsp;&nbsp;&nbsp;{releaseTitle}</div>
         </div>

         <div style={{display:'flex',flexDirection:'row',width:'81.81%',marginBottom:'1em'}}>
             <div className="AlbumInfoMeta">{t('Artisttag')}  </div>
             <div className="AlbumInfoValue">&nbsp;&nbsp;&nbsp;{artistName}</div>
         </div>

         <div style={{display:'flex',flexDirection:'row',width:'81.81%',marginBottom:'1em'}}>
             <div className="AlbumInfoMeta">{t('Labeltag')}  </div>
             <div className="AlbumInfoValue">&nbsp;&nbsp;&nbsp;N3RVE</div>
         </div>

         <div style={{display:'flex',flexDirection:'row',width:'81.81%',marginBottom:'1em'}}>
             <div className="AlbumInfoMeta">{t('Genretag')}  </div>
             <div className="AlbumInfoValue">&nbsp;&nbsp;&nbsp;{genre.value}</div>
         </div>

         <div style={{display:'flex',flexDirection:'row',width:'81.81%',marginBottom:'4em'}}>
             <div className="AlbumInfoMeta">{t('Formattag')}  </div>
             <div className="AlbumInfoValue">&nbsp;&nbsp;&nbsp;{format.value}</div>
         </div>


         <div style={{display:'flex',flexDirection:'row',width:'81.81%',justifyContent:'space-between',marginBottom:'1.5em'}}>
           <div className="SectionHeader">
           {t('Tracks')}
           </div>

           <div className="EditBtn" onClick={()=>{topFunction();
           if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
            navigate("/Dashboard/releasemusic/trackdetails")
          }

          if(decodeToken(cookies.get('token')).info.role==="label"){
            navigate("/dashboard/label/releasemusic/trackdetails")
          }}}>
           {t('Edit')}
             </div>
         </div>

         {
           files.map((file,index)=>{
             return (
               <div style={{display:'flex',flexDirection:'row',width:'79.81%',marginBottom:'1em'}}>
                 <div className="AlbumInfoTrackNo">
                   {index+1}.
                 </div>

                 <div style={{display:'flex',flexDirection:'column'}}>
                   <div className="AlbumInfoTrackName">
                     {file.Tracktitle}
                   </div>
                   {
                         file.Tracktitle.length!==0 &&
                         <div style={{display:'flex',flexDirection:'row',justifyContent:'center',marginLeft:'-1.5em',maxWidth:'30em',maxHeight:'1.5em',overflow:'hidden',flexShrink:'0'}}>
                           {
                               file.Arists.map((artist,index)=>{
                                 return (
                                   <div style={{display:'flex',flexDirection:'row',flexShrink:'0'}}>
                                   {
                                     (index===file.Arists.length-1) &&
                                     <div className="TrackInfo">
                                       {artist.name}/
                                     </div>
                                   }
                                  
                                   {
                                     (index>=0 && index!==file.Arists.length-1) &&
                                     <div className="TrackInfo">
                                      {artist.name},
                                     </div>
                                   }
                                   </div>
                                  
                                 )
                               })
                              }
                              {
                               file.Contributors.length!==0 &&
                               file.Contributors.map((contributor,index)=>{
                                 return (
                                   <div style={{display:'flex',flexDirection:'row',flexShrink:'0'}}>
                                     <div className="TrackInfo">
                                     &nbsp;{contributor.name},
                                     </div>
                                     <div className="TrackInfo">
                                     &nbsp;{contributor.roles[0].label},
                                     </div>
                                     {
                                       contributor.roles[1]!==undefined &&
                                       <div className="TrackInfo">
                                       &nbsp;{contributor.roles[1].label},
                                       </div>
                                     }
                                     {
                                       contributor.roles[2]!==undefined &&
                                       <div className="TrackInfo">
                                       &nbsp;{contributor.roles[2].label},
                                       </div>
                                     }
                                   </div>
                                 )
                               })
                              }
                               {
                               file.Publishers.length!==0 &&
                               file.Publishers.map((publisher,index)=>{
                                 return (
                                   <div style={{display:'flex',flexDirection:'row',flexShrink:'0'}}>
                                     <div className="TrackInfo">
                                     &nbsp;{publisher.name},
                                     </div>
                                     {

                                     }
                                     <div className="TrackInfo">
                                     &nbsp;{publisher.composer},
                                     </div>
                                   </div>
                                 )
                               })
                              }
                              {
                               file.Lyrics.length!==0 &&
                                   <div className="TrackInfo">
                                     &nbsp;{file.Lyrics},
                                     </div> 
                              }
                        
                         </div>
                       }
                 </div>
               </div>
             )
           })
         }

         <div style={{display:'flex',flexDirection:'row',width:'81.81%',justifyContent:'space-between',marginBottom:'1.5em',marginTop:'4em'}}>
           <div className="SectionHeader">
            {t('Releasedate')}
           </div>

           <div className="EditBtn" onClick={()=>{topFunction();
            if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
              navigate("/Dashboard/releasemusic/releasedate")
            }
  
            if(decodeToken(cookies.get('token')).info.role==="label"){
              navigate("/dashboard/label/releasemusic/releasedate")
            }}}>
           {t('Edit')}
             </div>
         </div>

          <div className="ReleaseDate">
         {releaseDate}
         </div>

         { 
         releaseDateError === 2 &&
         <div className="ReleaseDisclaimer">
          <Trans i18nKey="Yourreleasedateissooner" components={{1:<br/>}} >
          Your release date is sooner than we can confirm for all platforms. The launch might <br/> vary across platforms, but we'll keep you updated on delivery and go-live dates.
           </Trans>
         </div>
         }

         { 
         releaseDateError === 3 &&
         <div className="ReleaseDisclaimer">
         {t('Yourreleasedatreisgood')}
         </div>
         }
        

         <div className="TermsHeader">
         {t('Confirmtocontinue')} 
         </div>

         <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'83%'}}>
          
             <Checkbox size="medium"  checked={isChecked1} onChange={()=>setIsChecked1(!isChecked1)}  
               sx={{
                   [`&, &.${checkboxClasses.checked}`]: {
                       color: '#FFFFFF',
                     },
                   color: "#E91353",
                   '&.Mui-checked': {
                   color: "#E91353"
                   }
               }}
               />
            
            <div className="TermsTxt">
            {t('Allsubmittedmusicisori')} 
            </div>
         </div>

         <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'83%'}}>
          
          <Checkbox size="medium"  checked={isChecked2} onChange={()=>setIsChecked2(!isChecked2)}  
            sx={{
                [`&, &.${checkboxClasses.checked}`]: {
                    color: '#FFFFFF',
                  },
                color: "#E91353",
                '&.Mui-checked': {
                color: "#E91353"
                }
            }}
            />
         
         <span className="TermsTxt">
         {t('IagreewithTandC')} 
         </span>
      </div>


       </div>

      

       <div style={{display:'flex',flexDirection:'row',marginTop:'3.5em',paddingBottom:'4em'}}>
         <div className="BackBtnFinal" onClick={()=>{topFunction(); 
         if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
              navigate("/Dashboard/releasemusic/releasedate")
            }
            if(decodeToken(cookies.get('token')).info.role==="label"){
              navigate("/dashboard/label/releasemusic/releasedate")
            }
          }}
          >
         {t('Back')} 
         </div>

         {
           isChecked1 && isChecked2 && !btnclicked &&
           <div className="SubmitBtnFinal" onClick={()=>{
             SubmitReleaseMusic()
             setBtnClicked(true)
             setTimeLeft(6);setPageNo(8);topFunction()
           }}>
            {t('Submit')}
            <div className="PostLoginBtnOverlay"/>
           </div>
         }

        {
           isChecked1 && isChecked2 && btnclicked &&
           <div className="SubmitBtnFinal">
            <CircularProgress style={{width:'1em',height:'1em',marginLeft:'0%',cursor:'default'}} sx={{color:'#FFFFFF'}}/>
           
           </div>
         }

         {
           (!isChecked1 || !isChecked2) &&
           <div className="SubmitBtnFinal" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}
            >
           {t('Submit')}
           </div>
         }
        
       </div>
   </div>
        
    );
}

export default AlbumSummary;